import { render } from "./HomeSection.vue?vue&type=template&id=8e2e6a84&scoped=true"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"

import "./HomeSection.vue?vue&type=style&index=0&id=8e2e6a84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e2e6a84"]])

export default __exports__